import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <div className="bg-white min-h-screen pt-32 pb-20 px-6" data-id="element-277">
      <div className="max-w-[1200px] mx-auto text-center" data-id="element-278">
        <span className="text-[10px] font-display uppercase tracking-[0.5em] mb-4 block text-black/40" data-id="element-279">
          Our Story
        </span>
        <h1 className="text-4xl md:text-6xl font-display font-bold tracking-[0.2em] uppercase mb-12" data-id="element-280">
          About Djili
        </h1>
        <div className="aspect-video bg-grey-divider mb-16 grayscale" data-id="element-281">
          <img src="https://cdn.magicpatterns.com/uploads/3Axzh5yjUCYGZvVYAbBuxk/image.png" alt="Djili Creations Heritage" className="w-full h-full object-cover" data-id="element-282" />
        </div>
        <div className="max-w-2xl mx-auto text-left space-y-8" data-id="element-283">
          <p className="text-sm font-light tracking-widest text-black/70 leading-relaxed uppercase" data-id="element-284">
            Djili Creations was born from a desire to preserve the rich textile
            traditions of the African continent while pushing the boundaries of
            modern design.
          </p>
          <p className="text-sm font-light tracking-widest text-black/70 leading-relaxed uppercase" data-id="element-285">
            Every piece is a dialogue between the past and the future,
            handcrafted with precision and a deep respect for the hands that
            weave our stories.
          </p>
        </div>
      </div>
    </div>;
}